class FilesTabsController {
  constructor(
    $rootScope,
    article,
    concept,
    customer,
    supplier,
    rootFolderId,
    isArticle,
  ) {
    'ngInject';

    if (article) {
      $rootScope.pageTitle = `${article.itemCode || ''} - Files`;
    } else if (concept) {
      $rootScope.pageTitle = `${concept.name || ''} - Files`;
    } else if (customer) {
      $rootScope.pageTitle = `${customer.name || ''} - Files`;
    } else if (supplier) {
      $rootScope.pageTitle = `${supplier.name || ''} - Files`;
    }

    this.rootFolderId = rootFolderId;
    this.isArticle = isArticle;
  }
}

angular
  .module('tabs.files', [])
  .controller('FilesTabsController', FilesTabsController);
